import { Typography, SvgIconTypeMap } from "@mui/material";
import { SwipeableListItem, Type } from "react-swipeable-list";
import { BookmarkState } from "services/appStateService";
import { testId } from "tests/testIdStrings";
import { ListItemButton } from "utils/helpers/ListItemButton";
import { Icon, iconBookmarkSolid, iconArrowRightRegular } from "theme/icons";
import { swipeLeftAction } from "./bookmarksListItemSwipeAction";

type Props = {
  key: number;
  item: BookmarkState;
  handleDeleteDialog: (item: BookmarkState) => void;
};

export const SwipeableBookmarksListItem = ({ key, item, handleDeleteDialog }: Props) => {
  return (
    <SwipeableListItem listType={Type.IOS} trailingActions={swipeLeftAction(item, handleDeleteDialog)}>
      <ListItemButton
        key={item.key.contentId}
        primaryText={
          <Typography variant="breadcrumbs" noWrap>
            {item.title}
          </Typography>
        }
        secondaryText={
          <Typography variant="note" noWrap maxWidth="92%" minHeight={"20px"} display="inline-block">
            {item.text}
          </Typography>
        }
        to={item.key.contentId + "?type=" + item.type}
        dataTestIdString={`${testId.button.bookmarkItem}.${key + 1}`}
        startIcon={<Icon name={iconBookmarkSolid} color={item.color as SvgIconTypeMap["props"]["color"]} />}
        endText={
          <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
            {item.date}
          </Typography>
        }
        endIcon={<Icon name={iconArrowRightRegular} color="primary" />}
      />
    </SwipeableListItem>
  );
};
